// Shared emitter
import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();

export const PLAYER_START = 'player:start';
export const PRIVACY_SETTINGS_CONFIRMED = 'privacy-settings:confirmed';
export const TOGGLE_FACEBOOK_PIXEL_PERMISSIONS = 'toggle:facebook-pixel';
export const TOGGLE_GOOGLE_PIXEL_PERMISSIONS = 'toggle:google-pixel';
export const TOGGLE_SNAP_PIXEL_PERMISSIONS = 'toggle:snap-pixel';
export const TOGGLE_TIKTOK_PIXEL_PERMISSIONS = 'toggle:tiktok-pixel';
export const TOGGLE_PINTEREST_PIXEL_PERMISSIONS = 'toggle:pinterest-pixel';
export const SHOW_REACTION = 'show:reaction';
export const SVG_FILL = 'svg-manager:fill';

export default eventEmitter;
